import intlTelInput from "../libs/intlTelInput";

export function inputPhoneFunction() {
    const input = document.querySelector("#phone");
    const code = document.querySelector("#country_code");
    const iti = intlTelInput(input, {});

    if(!!code) {
        code.value = "+" + iti.getSelectedCountryData().dialCode;
        input.addEventListener("countrychange", function (e) {
            code.value = "+" + iti.getSelectedCountryData().dialCode;
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/inputPhoneFunction.js